"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoInputTemplate = exports.logoButtonTemplate = exports.logoImageTemplate = exports.logoTemplate = void 0;
var tslib_1 = require("tslib");
var logo_dot_1 = (0, tslib_1.__importDefault)(require("./logo.dot"));
var logo_image_dot_1 = (0, tslib_1.__importDefault)(require("./logo-image.dot"));
var logo_input_dot_1 = (0, tslib_1.__importDefault)(require("./logo-input.dot"));
var logo_button_dot_1 = (0, tslib_1.__importDefault)(require("./logo-button.dot"));
var logoTemplate = logo_dot_1.default.default ? logo_dot_1.default.default : logo_dot_1.default;
exports.logoTemplate = logoTemplate;
var logoImageTemplate = logo_image_dot_1.default.default ? logo_image_dot_1.default.default : logo_image_dot_1.default;
exports.logoImageTemplate = logoImageTemplate;
var logoInputTemplate = logo_input_dot_1.default.default ? logo_input_dot_1.default.default : logo_input_dot_1.default;
exports.logoInputTemplate = logoInputTemplate;
var logoButtonTemplate = logo_button_dot_1.default.default ? logo_button_dot_1.default.default : logo_button_dot_1.default;
exports.logoButtonTemplate = logoButtonTemplate;
//# sourceMappingURL=index.js.map